import React from "react";
import { Clock, Layers, Send, Timer, Zap } from "lucide-react";

function KpiTile({ label, value, hint, accent, icon: Icon, onClick, active }) {
    const rings = {
        sky: "border-sky-500/40 from-sky-500/12",
        violet: "border-violet-500/40 from-violet-500/12",
        amber: "border-amber-500/40 from-amber-500/12",
        emerald: "border-emerald-500/40 from-emerald-500/12",
        red: "border-rose-500/40 from-rose-500/12",
        slate: "border-slate-500/30 from-slate-500/8",
    };
    const Tag = onClick ? "button" : "div";
    return (
        <Tag
            type={onClick ? "button" : undefined}
            onClick={onClick}
            className={`rounded-xl border bg-gradient-to-br to-[#0B0F19]/90 p-4 text-left transition-all ${
                rings[accent] || rings.violet
            } ${onClick ? "hover:scale-[1.02] cursor-pointer hover:border-violet-400/50" : ""} ${
                active ? "ring-2 ring-violet-400/50" : ""
            }`}
        >
            <div className="flex items-start justify-between gap-2">
                <div className="text-[10px] uppercase tracking-[0.14em] text-slate-500">{label}</div>
                {Icon ? <Icon className="h-4 w-4 text-slate-500 shrink-0" /> : null}
            </div>
            <div className="font-display text-2xl text-white mt-1 tabular-nums">{value ?? "—"}</div>
            {hint ? <div className="text-[11px] text-slate-500 mt-1.5">{hint}</div> : null}
        </Tag>
    );
}

export default function TahkimOnTahkimKpiStrip({
    ozet,
    filterDurum,
    segment,
    onFilterDurum,
    onSegment,
}) {
    if (!ozet) return null;

    return (
        <div className="space-y-3">
            <div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
                <KpiTile
                    label="Toplam ön tahkim"
                    value={ozet.toplam_on_tahkim}
                    hint="Bekleyen + aktif"
                    accent="sky"
                    icon={Layers}
                    onClick={() => onSegment?.("tumu")}
                    active={segment === "tumu" && !filterDurum}
                />
                <KpiTile
                    label="Aktif ön tahkim"
                    value={ozet.aktif_on_tahkim}
                    hint="Kanban ON_TAHKIM"
                    accent="violet"
                    icon={Zap}
                    onClick={() => onSegment?.("aktif")}
                    active={segment === "aktif"}
                />
                <KpiTile
                    label="Bekleme kuyruğu"
                    value={ozet.toplam_bekleyen}
                    hint="Başvuru süresi işliyor"
                    accent="slate"
                    icon={Timer}
                    onClick={() => onSegment?.("bekleyen")}
                    active={segment === "bekleyen" && !filterDurum}
                />
                <KpiTile
                    label="Geçişe hazır"
                    value={ozet.hazir_ve_gecikti}
                    hint="Manuel / otomatik geçiş"
                    accent="emerald"
                    icon={Send}
                    onClick={() => {
                        onSegment?.("bekleyen");
                        onFilterDurum?.("HAZIR");
                    }}
                    active={filterDurum === "HAZIR" || filterDurum === "GECIKTI"}
                />
                <KpiTile
                    label="Yaklaşan"
                    value={ozet.durum?.YAKLASIYOR || 0}
                    hint="7 gün içinde süre dolacak"
                    accent="amber"
                    icon={Clock}
                    onClick={() => {
                        onSegment?.("bekleyen");
                        onFilterDurum?.("YAKLASIYOR");
                    }}
                    active={filterDurum === "YAKLASIYOR"}
                />
            </div>

            <div className="flex flex-wrap gap-1.5">
                {[
                    ["BEKLIYOR", "Bekliyor"],
                    ["YAKLASIYOR", "Yaklaşıyor"],
                    ["HAZIR", "Hazır"],
                    ["GECIKTI", "Gecikti"],
                ].map(([key, label]) => (
                    <button
                        key={key}
                        type="button"
                        onClick={() => {
                            onSegment?.("bekleyen");
                            onFilterDurum?.(filterDurum === key ? "" : key);
                        }}
                        className={`px-2.5 py-1 rounded-lg text-[10px] font-semibold uppercase border transition ${
                            filterDurum === key
                                ? "border-violet-500/50 bg-violet-500/15 text-violet-200"
                                : "border-white/10 text-slate-500 hover:text-slate-300 hover:bg-white/5"
                        }`}
                    >
                        {label} · {ozet.durum?.[key] || 0}
                    </button>
                ))}
            </div>
        </div>
    );
}
